import { useState, useEffect } from 'react';
import { NotificationError } from '../utils/notification';

interface UseFetchDataProps {
  apiFunction: (params: any) => Promise<any>;
  initialParams: any;
  toasts: any[];
  setToasts: (toasts: any[]) => void;
}

const useFetchTableData = ({
  apiFunction,
  initialParams,
  toasts,
  setToasts,
}: UseFetchDataProps) => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);

  useEffect(() => {
    fetchData(initialParams);
  }, []);

  const fetchData = async (params: any) => {
    
    setIsLoading(true);
    try {
      const response = await apiFunction(params);
      if (response) {
        setData(response);
      }
    } catch (error) {
      setToasts([...toasts, ...NotificationError('AN_ERROR_OCCURRED')]);
    }
    setIsLoading(false);
  };

  const handlePageNumberClick = (pageNumber: number) => {
    window.scrollTo(0, 0);
    fetchData({ ...initialParams, pageNo: pageNumber - 1 });
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (e: React.MouseEvent<HTMLElement>, pageSize: number) => {
    fetchData({ ...initialParams, pageNo: 0, pageSize });
    setCurrentPage(1);
  };

  return {
    data,
    isLoading,
    currentPage,
    fetchData,
    handlePageNumberClick,
    handlePageSizeChange,
  };
};

export default useFetchTableData;
